
    
  import React, { useReducer } from "react";
  import axios2 from 'services/axios2';

  import {useParams} from "react-router-dom";
  import {Link,hashHistory} from 'react-router-dom';
  import { ToastContainer, toast } from 'react-toastify';
  import { NuDropdown } from "components/nubox/NuDropdown";

  import ImageUpload from "components/nubox/ImageUpload";
  import NuConfirm from "components/nubox/Box/NuConfirm";
  import { withRouterJim } from "router/withRouterJim";
  
  import Box_buscar_materia from 'views/_box/Box_buscar_materia'; 

  import user2 from "assets/img/user2.png"
  import { NotificationContainer, NotificationManager } from 'react-notifications';
  import {
    Table,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    ModalFooter,
    ToastHeader,
  } from "reactstrap";

  const cbo=[
    {  value:'1', label: 'label1'},
  ]
  
  const initialForm={
    id_u:'',
    nro_doc:'',
    nomape_tmp:'',
    dir:'',
    tel:'',
    foto_path1:'',
    estado:0,
  }
  //$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
  class PlanEstudios extends React.Component {
    modalRef = React.createRef();//create ref

    state = {
      modalInsertar: false, //box materia
      materia_selected:{}, //seleccionada del box

      modalImagen: false,
      id_carre:0,  //desde parametros
      
      form: Object.assign({}, initialForm),
        
      data: [],/* tabla  */
      
    };
    //--------------------------------------
    constructor(props) {
      super(props);

      this.refNuConfirm = React.createRef();
    }
    //------------------
    //---------------------------------
    componentDidMount() {
      //--limpiamos el array de prueba
      this.setState({data:[]});
  
      // Get the userId param from the URL.
      //let id_est = this.props.params.id;
      //let id_peri = this.props.store.user.id_peri;

      let id_carre = this.props.store.user.id_carre
      //let id_peri = this.props.store.user.id_peri
            
      
      this.cargar_data(id_carre); //carga del periodo de el store
            
      //---actualizamos el estado
      this.setState({id_carre: id_carre})
    }
    //----------------especial, actualiza valores del form -------------------------------
    handleChangeForm = (e) => {
      //requerimos la prop name='?' en cada control
      
      //--- esto lo hacemos porque en vez de utilizar valores true, false
      //--- tenemos que utilizar 1, 0
      if(e.target.type==="checkbox"){

        let res = e.target.checked? 1:0;        
        this.setState({
          form:{
            ...this.state.form,
            [e.target.name]: res,
          }
        })
      }else{
        this.setState({
          form: {
            ...this.state.form,
            [e.target.name]: e.target.value,
          },
        });
      }
    };
    //-----------------------------------------
    cargar_data = (id_carre) => {      
      console.log("cargar_data");
      let param = { 
        id_carre: id_carre,
      }
      console.log(param);
      axios2.post( "plan_estudio_get_list", param)
      .then(res => {
          console.log(res.data);
          if( res.data!==''){ 
              //cargamos el estudiante
              this.setState({data: res.data});
              
          }else{
            toast.error("Registro no encontrado", {
              position: toast.POSITION.TOP_RIGHT
            });
          }
  
      }).catch(error => {
          alert("---- Existio un error ---");
          console.log(error);
      });
    };
  //------------------------------
  render() {
    return (
      <div>
        <ToastContainer />
        <div className="content">

          {/* ---   --- */}
          <section className="content-header">
            <div className="" style={{ textAlign:'center' }}>
              <h3 className="text-muted">Plan de estudios</h3>
            </div>
            {/**/}

          

       
        </section>


          <section className="content">
            <h5 className="text-bold">
              Carrera: 
            </h5>
            {/*
            <button className="btn btn-sm btn-default" onClick={(e)=> this.buscar_materia_click(e)} >
              <i className="fa fa-plus"></i> Agregar
            </button>
            */}
            <div className="col-md-10">
              <div className="card">

                <div className="card-body">
                  {/*-- */}
                  <div className="row">
                    <table className='table table-striped' width='100%' align='center'>
                      <thead>
                        {/*
                        <tr>
                          <th>Cod.</th>
                          <th>Nivel</th>
                    
                        </tr>
                        */}
                      </thead>
                      <tbody>
                        {/* className='text-left' */}
                        {/*
                        {
                            "id_nivel": 1,
                            "nivel": "Primero",
                            "materias": [
                              {
                                "materia": {
                                  "id_mate": 45,
                                  "sigla": "BIA221",
                                  "nombre": "BIOESTADISTICA E INFORMATICA",
                                  "grupo": 1
                                }
                              },
                              {
                                "materia": {
                                  "id_mate": 50,
                                  "sigla": "BIA221",
                                  "nombre": "BIOESTADISTICA  E INFOMATICA",
                                  "grupo": 2
                                }
                              },
                              {
                                "materia": {
                                  "id_mate": 51,
                                  "sigla": "BIA221",
                                  "nombre": "BIOESTADISTICA E INFORMATICA",
                                  "grupo": 3
                                }
                              }
                            ]
                        }
                         */}
                        {this.state.data.map((item, index) => (
                          <>
                          <tr key={index}>
                            
                            <td>{item.id_nivel}</td>
                            <td>{item.nivel}</td>
                          </tr>
                          <tr>
                            <td colSpan={4} className=" text-center ">
                              <table className="tabla_cafe">
                                <thead>
                                  <tr>
                                    <th>Cod Mat.</th>
                                    <th>Sigla</th>
                                    <th>nombre</th>
                                    <th>grupo</th>
                                  </tr>
                                </thead>
                                <tbody>
                                { item.materias.map((item2, index2) => (
                                  <tr key={item2.id_mate} >
                                    <td>{item2.id_mate}</td>
                                    <td>{item2.sigla}</td>
                                    <td>{item2.nombre}</td>
                                    <td>{item2.grupo}</td>
                                  </tr>
                                ))}
                                </tbody>
                              </table>
                            </td>                     

                          </tr>
                          </>
                        ))}



                      </tbody>
                    </table>
                  </div>
                  {/*-- */}



                </div>

                <div className="card-footer">
                  <div className="form-group">
                    <div className="text-center">
                      {/*<Button onClick={this.aceptar_click} className="btn btn-primary">
                        <i className="fa fa-floppy-o"></i>&nbsp;
                        Guardar
                      </Button>
                      &nbsp;
                      <Link to='/DocenteList' className="btn btn-default">Volver</Link>
                        */}
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div className="col-md-2">

            </div>
          </section>
        </div>


        

        <NuConfirm   ref={ this.refNuConfirm }    />
      </div>
    );
  }
}
  
//------------para que soporte la funcionalidad de parametros
export default withRouterJim(PlanEstudios);